import React, {
  Fragment,
  useEffect,
  useState,
  useContext,
  useRef,
} from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { Context } from "../context";
import uniqid from "uniqid";
import {
  getImage,
  getDataById,
  minToHours,
  getDataByUniq,
  getMetadataCategories,
  handleUrl
} from './utils';
import { HoverScrubber } from "./Scrubber";
import { SCREEN_RATIO } from "../config";
import { PlaylistTop } from "./PlaylistTop";
import { PlaylistAddButton } from "./PlaylistAddButton";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import { UserBadge } from './UserBadge';
import { ContentList } from './ContentList';
import { Svg } from '../uikit/Svg';
import { SkeletonPreloader } from '../uikit/SkeletonPreloader';
import { Preloader, Preloader0 } from '../uikit/Uikit';

export function PlaylistInner({ history, match, playlistId }) {
  const [expanded, setExpanded] = useState(true);
  const context = useContext(Context);

  const filterVideos = (playlistId, app, user) => { };

  return (
    <>
      {/* <div
      className={`l_playlist ${expanded ? "l_playlist--md" : "l_playlist--"}`}
    > */}
      {/* <div className="h0">
        <div
          className="ui_tabs ui_tabs--expandable"
          onClick={() => setExpanded(!expanded)}
        >
          <div className="ui_tabs__ul">
            <div className="ui_tabs__li">
              <div className="ui_tabs__menu_item ui_tabs__menu_item--header">
                <div>Streams</div>
                <div className="m_ico m_ico--rotate">
                  {!expanded && <div>unfold_more</div>}
                  {expanded && <div>unfold_less</div>}
                </div>
              </div>
            </div>
            <div className="ui_tabs__li ui_tabs__li--right">
          </div>
          </div>
        </div>
      </div> */}

      <div className="l_playlist">

        {playlistId && (
          <>
            <PlaylistTop
              playlistId={playlistId}
              {...getDataById(context, "playlists", playlistId)}
            // handleMenu={() => setMenu()}
            />
          </>
        )}

        {/* <Playlist playlistId={playlistId} /> */}

        {/* <div className="l_thumbs_day"> */}
        {/* <PerfectScrollbar className={`l_thumbs_ul`}> */}


        <ContentList playlistId={playlistId} userId={context.user['id']} />



        {/* </PerfectScrollbar> */}
        {/* </div> */}


      </div>
    </>
  );
}


const PlaylistItemInner = (props) => {
  const context = useContext(Context);
  const {
    processing = false,
    active,
    id,
    uniq,
    url,
    img,
    title,
    date,
    length,
    user,
    userImg,
    app,
    sprite,
    metadata,
    history,
    match,
    location,
    key,
    addToPlaylist
  } = { ...props };

  const videoId = id;



  // console.log(getDataById(context, "apps", app, "url"));
  // console.log("app", app);

  const imageContainer = useRef();

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const [dimensions, setDimensions] = React.useState({
    wHeight: window.innerHeight,
    wWidth: window.innerWidth,
  });

  useEffect(() => {
    function handleResize() {
      setDimensions({
        wHeight: window.innerHeight,
        wWidth: window.innerWidth,
      });
    }
    window.addEventListener("resize", handleResize);
  });

  useEffect(() => {
    // console.log(
    //   "imageContainer.current.offsetWidth = ",
    //   imageContainer.current.offsetWidth
    // );
    if (width !== imageContainer.current.offsetWidth) {
      setWidth(imageContainer.current.offsetWidth);
    }
    if (height !== imageContainer.current.offsetHeight) {
      // setHeight(imageContainer.current.offsetHeight)
      setHeight(width * SCREEN_RATIO);
    }
  }, [imageContainer, match, dimensions]);

  // useEffect(() => {
  //   console.log('getMetadataCategories(context, videoId, sort) = ', getMetadataCategories(context, videoId, 'sort'));
  // }, [])

  return (
    <div
      key={key}
      className="l_thumbs_li"
      onClick={() => {
        if (addToPlaylist) {
          //TODO: handler for adding the video to a playlist
        } else {
          handleUrl(history, match, id, '')
        }
      }}
      ref={imageContainer}
    >
      <div className={`ui_video_element ${active ? "active" : ""} ${processing ? "ui_video_element--processing" : ""}`}   >

        {Boolean(addToPlaylist) && <div className="ui_video_element_add">
          <div className="x_button x_button--add"><div className="x_button_icon"><div>add</div></div></div>
        </div>}

        {/* <div className="ui_video_element_bg" /> */}

        {/* <div className="p_thumbs_ava">
          <img
            src={getImage(getDataById(context, "apps", app, "img"))}
            loading="lazy"
            alt={getDataById(context, "apps", app, "title")}
            className="p_user_ava_img"
          />
        </div> */}




        <CSSthumb
          className="l_thumbs_vid"
          style={{
            // height: width * SCREEN_RATIO,
            backgroundImage: 'none',
            // backgroundImage: `url(https://img.youtube.com/vi/${url}/0.jpg)`,
          }}
        >



          {!processing && getDataById(context, "apps", app) && <div className="p_thumbs_ava">
            <img
              src={getImage(getDataById(context, "apps", app, "img"))}
              loading="lazy"
              alt={getDataById(context, "apps", app, "title")}
              className="p_user_ava_img"
            />
          </div>}





          {!processing && <div className="ui_video_element_timestamp">{minToHours(length)}</div>}


          {!processing && <div className="ui_video_scrubber">
            <HoverScrubber
              width={width}
              height={width * SCREEN_RATIO}
              sprite={sprite}
            />
          </div>}

          {processing && 'Processing...'}

          {/* <img src={getImage(img, "full")} loading="lazy" sizes="100px" /> */}
        </CSSthumb>

        <div className="ui_video_element_info">




          <div href="#" className="ui_video_element_info_text">
            <div>{title}</div>
          </div>

          <UserBadge userId={user} />



          <div className="ui_video_element_top">
            <div className="ui_video_element_metatop">
              {Boolean(getMetadataCategories(context, videoId, "sort").length) &&
                getMetadataCategories(context, videoId, "sort").map((typeRef) => {
                  let typeData = getDataById(context, "metaDataTypes", typeRef);
                  let metadataLength = context.data.metadata.filter(
                    (oneMetadata) => {
                      let r =
                        oneMetadata["typeRef"] === typeRef &&
                        oneMetadata["videoId"] === videoId;
                      return r;
                    }
                  ).length;

                  return (
                    <>
                      {typeData && (
                        <div
                          key={`tag_${typeData["id"]}`}
                          className="ui_video_tag"
                          style={{ color: typeData["color"] }}
                        >
                          <div
                            className="ui_video_tag_bg"
                            style={{ backgroundColor: typeData["color"] }}
                          />
                          {typeData["title"]}
                          <div className="x_meta_title_nums0">
                            <div className="x_meta_title_num">
                              {metadataLength}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
            </div>
          </div>

        </div>

      </div>


    </div>
  );
};

const CSSthumb = styled.div`
  /* & .ui_video_scrubber {
    opacity: 0;
  }
  &:hover .ui_video_scrubber {
    opacity: 1;
  } */
`;

export const PlaylistItem = withRouter(PlaylistItemInner);
export const Playlist = withRouter(PlaylistInner);
